import { useEffect } from 'react';

export const useInjectForgotPassword = (onForgotPassword: () => void): void => {
  useEffect(() => {
    const passwordInput = document.querySelector<HTMLInputElement>('input[name="password"]');
    const label = passwordInput?.id
      ? document.querySelector<HTMLElement>(`label[for="${passwordInput.id}"]`)
      : document.querySelector<HTMLElement>('.amplify-passwordfield .amplify-label');
    if (!label || label.querySelector('.forgot-password-injected')) {
      return;
    }
    label.style.display = 'flex';
    label.style.justifyContent = 'space-between';

    const span = document.createElement('span');
    span.className = 'forgot-password-injected';
    span.textContent = 'Wachtwoord vergeten?';
    span.onclick = onForgotPassword;
    label.appendChild(span);

    return () => {
      span.remove();
    };
  }, [onForgotPassword]);
};
